export const DEFAULT_PRODUCT_IMAGE =
  'https://ordering-sfv4.s3.eu-west-1.amazonaws.com/storefrontassets/prod/assets/images/fallbackImages/ItemEmptystate.png';
